// extracted by mini-css-extract-plugin
export default {"scroll":"scrollup_scroll__f38E0"};